
import { Swiper, SwiperSlide } from 'swiper/react';// 引入需要的模块
import { Navigation, Autoplay } from 'swiper/modules';
import { Header } from './Header';
import { Cover } from './Cover';
import { Content } from './Content'; 
import { usePageScroll } from './usePageScroll';
import { Footer } from '../../components/Footer';
import './home.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useEffect, useRef, useState } from 'react';
function HomeSwiperPage() {
  const { topHeight } = usePageScroll({ pageCount: 1, lastPageOffset: 0 });
  const [currentIndex, setCurrentIndex] = useState(0);
  // 1. 创建 ref 指向自定义按钮
  const prevButtonRef = useRef(null);
  const nextButtonRef = useRef(null);
  const swiperRef = useRef<any>(null);
  useEffect(() => {
  if (
    swiperRef.current &&
    prevButtonRef.current &&
    nextButtonRef.current
  ) {
    swiperRef.current.params.navigation.prevEl = prevButtonRef.current;
    swiperRef.current.params.navigation.nextEl = nextButtonRef.current;

    swiperRef.current.navigation.init();
    swiperRef.current.navigation.update();
  }
}, []);
  // 幻灯片数据数组
  const slidesData = [
    {
      imgSrc: '/image/screen1.png',
      title: '秒速开盒，即刻揭晓',
      text: '极简操作流程无需等待，一键抽盒，瞬时解锁时尚数码好物 ',
      width: '40rem',
      height: '45.31rem',
    },
    {
      imgSrc: '/image/screen2.png',
      title: '正品严选，品质无忧', 
      text: '男女首饰时尚单品、数码产品全系正品，层层质检杜绝假货 ', 
      center: true,
        width: '35.19rem',
      height: '42.75rem',
    },
    {
      imgSrc: '/image/screen3.png',
      title: '贴心客服，全程相伴', 
      text: '贴心客服答疑，全流程跟进，解决各类下单售后问题',
      width: '31.25rem',
      height: '34.94rem',
      center: true,
    },
    { 
      title: '极速物流，速达好物', 
      text: '下单高效发货，全程极速配送，潮流好物快速送到手中',
      width: '31.81rem',
      height: '31.81rem',
    },
  ];
  return (
    <div className="main">
      <div
        className="wrapper"
        style={{
          transform: `translate3d(0px, ${-topHeight}px, 0px)`,
          transitionDuration: '0.8s',
          transitionDelay: '0ms',
        }}
      ><Header />
        <Swiper
          modules={[Navigation, Autoplay]}
          spaceBetween={0}
          slidesPerView={1}
          speed={900}
         navigation={{
  prevEl: prevButtonRef.current,
  nextEl: nextButtonRef.current,
}}
          onBeforeInit={(swiper: any) => {
            if (typeof swiper.params.navigation !== 'boolean') {
              swiper.params.navigation.prevEl = prevButtonRef.current;
              swiper.params.navigation.nextEl = nextButtonRef.current;
            }
          }}
          autoplay={{
            delay: 10000,           // 10秒切换
            disableOnInteraction: true, // 用户操作后是否停止自动播放，true 表示继续 
          }}
          onSwiper={(swiper: any) => { 
             swiperRef.current = swiper;
          }}
          onSlideChange={(swiper: any) => {
            setCurrentIndex(swiper.activeIndex);
          }}
        >
          {slidesData.map((slide, index) => (
            <SwiperSlide key={index}>
              <div className="page" style={{ backgroundImage: `url(/image/${index==3?'screen4.png':'background.png'})` }}>

                <div className="wrap" style={{ ['--cover-width' as any]: slide.width, ['--cover-height' as any]: slide.height }}>
                 
                  <Content title={slide.title} text={slide.text} />
                   <Cover center={slide.center}>
                    {slide.imgSrc && <img src={slide.imgSrc} />}
                  </Cover>
                </div> 
              
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
          <div className="dots" >
                  {slidesData.map((item, activeIndex) => (
                    <div   key={activeIndex} className={`dot ${activeIndex==currentIndex?'active':''}`} onClick={() => swiperRef.current?.slideTo(activeIndex)}/> 
                  ))}
                </div>
        {/* <div className="custom-navigation">
          <button ref={prevButtonRef} className="custom-prev">
            <img src="/image/arrow-left.png" />
          </button>
          <button ref={nextButtonRef} className="custom-next">
            <img src="/image/arrow-right.png" />
          </button>
        </div> */}


      </div>
    
        {/* 底部 */}
        <Footer />
    </div>
  );
}

export default HomeSwiperPage;